var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareScreenNoBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.54,
    height: 18.458,
    viewBox: "0 0 18.54 18.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share-screen-no-back-icon",
    d: "M2.317,18.458A2.319,2.319,0,0,1,0,16.15V2.307A2.319,2.319,0,0,1,2.317,0H6.953a1.154,1.154,0,1,1,0,2.307H2.317V9.229H6.953A2.319,2.319,0,0,1,9.27,11.536V16.15h6.953V11.536a1.159,1.159,0,0,1,2.317,0V16.15a2.319,2.319,0,0,1-2.317,2.307Zm0-2.307H6.953V11.536H2.317Zm13.905-9.23V3.938l-3.816,3.8a1.156,1.156,0,1,1-1.638-1.631l3.816-3.8h-3a1.154,1.154,0,1,1,0-2.307h5.794a1.159,1.159,0,0,1,1.159,1.154V6.921a1.159,1.159,0,0,1-2.317,0Z",
    transform: "translate(0 0)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenNoBackIcon);
export default __webpack_public_path__ + "static/media/share-screen-no-back-icon.5e109c9d21ed3b870e73b893d99234fd.svg";
export { ForwardRef as ReactComponent };